import React, { Component, FormEvent } from 'react'
/**
 * Old ( existing )
 *
 *     "apollo-boost": "0.4.4",
 *     "apollo-client": "^2.6.4",
 *     "react-apollo": "^3.1.1",
 *
 */
// import { gql } from 'apollo-boost'
import { ChildDataProps, graphql } from '@apollo/client/react/hoc'
import { gql } from '@apollo/client'
import { navigate } from 'gatsby'
import { isEmpty, words } from 'lodash'
import uniqid from 'uniqid'

// eslint-disable-next-line import/no-extraneous-dependencies
import { SearchBar, SearchResults, Overlay, SearchFilter } from 'suf_storybook'

import { compose } from '../lib'

import hasRuntimeQuery from './hocs/hasRuntimeQuery'
import hasLoading from './hocs/hasLoading'

export enum Constants {
  SECTORS = 'Sectors',
  ENTITIES = 'Entities',
  INSIGHTS = 'Insights'
}

const minimumTermLength = 2

export enum SearchItem {
  All = 'ALL'
}

type Props = {
  isOpen?: boolean
  handleMenuClick: () => void
}

type State = {
  query: string
}

type InputProps = {
  query: string
  item: string
  filter: SearchFilter
}
type Response = { search: any }
type Variables = {
  item: string
  term: string
  filter: object
}
type ChildProps = ChildDataProps<InputProps, Response, Variables>

const hasSearch = graphql<InputProps, Response, Variables, ChildProps>(
  gql`
    query Suggest(
      $item: SearchItem
      $term: String!
      $filter: SearchFilterInput
    ) {
      suggest(item: $item, term: $term, filter: $filter) {
        research {
          title
          permalink
        }
        entity {
          name
          permalink
          ultimateParent
        }
        pageTopic {
          title
          slug
        }
        pageRegion {
          title
          slug
        }
        pageMarketSector {
          title
          slug
        }
        pageCriteria {
          title
          slug
        }
        totalHits
      }
    }
  `,
  {
    options: ({ item, query, filter }) => ({
      key: uniqid(),
      fetchPolicy: 'no-cache',
      variables: { item, term: query, filter }
    })
  }
)

const Results = compose([hasRuntimeQuery, hasSearch, hasLoading])((props) => {
  const { data = {}, handleMenuClick } = props
  const { suggest = {} } = data

  const entityItems = suggest
    ? suggest.entity.map((item: any) => {
        if (!item) return {}
        const isCreditSummary = !isEmpty(
          words(item.permalink, /\bcredit-summary\b/)
        )
        return {
          creditSummary: isCreditSummary,
          slug: `entity/${item.permalink}`,
          title: item.name,
          ultimateParent: item.ultimateParent,
          renderLink: handleMenuClick
        }
      })
    : null

  const researchItems = suggest
    ? suggest.research.map((item: any) => {
        return {
          ...item,
          slug: item.permalink,
          renderLink: handleMenuClick
        }
      })
    : null

  const pageTopicItems = suggest
    ? suggest.pageTopic.map((item: any) => {
        return {
          ...item,
          renderLink: handleMenuClick
        }
      })
    : null

  const pageRegionItems = suggest
    ? suggest.pageRegion.map((item: any) => {
        return {
          ...item,
          renderLink: handleMenuClick
        }
      })
    : null

  const pageMarketSectorItems = suggest
    ? suggest.pageMarketSector.map((item: any) => {
        return {
          ...item,
          renderLink: handleMenuClick
        }
      })
    : null

  const pageCriteriaItems = suggest
    ? suggest.pageCriteria.map((item: any) => {
        return {
          ...item,
          renderLink: handleMenuClick
        }
      })
    : null

  return (
    <SearchResults
      entityItems={entityItems}
      pageTopicItems={pageTopicItems}
      pageRegionItems={pageRegionItems}
      pageMarketSectorItems={pageMarketSectorItems}
      pageCriteriaItems={pageCriteriaItems}
      researchItems={researchItems}
    />
  )
})

export default class SearchOverlayComponent extends Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      query: ''
    }
  }

  handleMenuItemClick = (slug: string, title: string) => {
    const { handleMenuClick } = this.props
    const url = title && title === Constants.INSIGHTS ? `/${slug}` : `/${slug}`
    handleMenuClick()
    this.setState({
      query: ''
    })
    navigate(url)
  }

  handleChange = (event: FormEvent<HTMLInputElement>) => {
    this.setState({ query: event.currentTarget.value })
  }

  handleSubmit = (event: FormEvent) => {
    if (event) event.preventDefault()
    const { query } = this.state
    window.location.assign(`/search?query=${encodeURIComponent(query)}`)
    const { handleMenuClick } = this.props
    handleMenuClick()
  }

  render() {
    const { isOpen = false } = this.props
    const { query } = this.state
    return (
      <Overlay
        isOpen={isOpen}
        className="search__overlay overlay-content-wrapper"
      >
        <div className="wrapper--1 content">
          <SearchBar
            handleSubmit={this.handleSubmit}
            handleChange={this.handleChange}
            query={query}
          />
        </div>
        <div className="wrapper--1">
          {query && query.trim().length >= minimumTermLength ? (
            <Results
              item={SearchItem.All}
              query={query.trim()}
              filter={{ sustainableFitchFlag: ['true'] }}
              handleMenuClick={this.handleMenuItemClick}
            />
          ) : null}
        </div>
      </Overlay>
    )
  }
}
